/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';

  app.CartItemsView = app.RestItemsView.extend({
    el: '.backbone-cart-items-view',
    additionalOptions: ['mainWindow', 'bodyView', 'isDynamicDeliverySegment', 'currency'],
    run: function () {
      this.cart = this.model;
      this.childViews.itemViews = [];
      this.initDynamicItemDeliveryCost();
      this.initLoader();
      this.updateItemsView();
      this.listenTo(this.model, 'reset', this.updateItemsView);
      /**
       * Обновление коллекции при смене города.
       */
      this.listenTo(this.settlement, 'sync', function () {
        this.model.fetch();
      });
      if (!app.isMobile) {
        this.listenToOnce(this, 'rendered', this.initGridView);
      }
      this.$el.html('');
    },

    /**
     * Инициализация прелоадера.
     */
    initLoader: function() {
      this.childViews.loader = new app.LoaderView({
        contentWrapper: this.$el.parent(),
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
      });
      this.childViews.loader.render();
      this.listenTo(this.model, 'request sync', this.updatePreloaderState);
    },

    /**
     * Обновление состояния прелоадера.
     */
    updatePreloaderState: function() {
      if (this.cart.isFetching && this.cart.totalCount) {
        this.childViews.loader.render();
      } else {
        if (this.cart.totalCount || !_.isEmpty(this.cart.giftsForActions)) {
          this.childViews.loader.remove();
        }
      }
    },

    /**
     * @inheritDoc
     */
    initRemoveCheckedListener: function () {
      this.listenTo(this.childViews.gridHeaderView, 'remove-checked', this.removeCheckedFromCart);
    },
    updateItemsView: function () {
      if (this.model.isScroll) {
        this.updateNewItemsView();
      } else {
        this.updateAllItemsView();
      }
    },
    updateAllItemsView: function () {
      this.items = this.model.models.slice();
      this.childViews.itemViews = [];
      _.each(this.items, function (item) {
        this.childViews.itemViews[this.childViews.itemViews.length] = new app.CartItemView({
          user: this.user,
          model: item,
          cart: this.cart,
          mainWindow: this.mainWindow,
          settlement: this.settlement,
          bodyView: this.bodyView,
          currency: this.currency,
        });
      }.bind(this));
      this.renderAll();
    },

    updateNewItemsView: function () {
      var newItems = this.model.models.slice().filter(function (model) {
        return this.items.indexOf(model) < 0;
      }.bind(this));
      this.items = this.model.models.slice();
      var newItemsView = [];
      _.each(newItems, function (item) {
        item = this.childViews.itemViews[this.childViews.itemViews.length] = new app.CartItemView({
          model: item,
          cart: this.cart,
          mainWindow: this.mainWindow,
          settlement: this.settlement,
          user: this.user,
          currency: this.currency,
          bodyView: this.bodyView,
        });
        newItemsView[newItemsView.length] = item;
      }.bind(this));
      this.renderNew(newItemsView);
      this.model.isScroll = false;
    },

    renderAll: function () {
      this.$el.html('');
      this.render(this.childViews.itemViews);
    },

    renderNew: function (newItemsView) {
      this.render(newItemsView);
    },

    render: function (itemsView) {
      var that = this,
        itemsViewLength = itemsView.length;

      // высота задается, чтобы не ломалась верстка при  рендеринге РР
      this.minHeight = '330px';

      if (itemsViewLength < 3 && itemsViewLength > 0) {
        this.$el.css('min-height', this.minHeight);
      }
      if (itemsViewLength) {
        _.each(itemsView, function (itemView) {
          that.el.appendChild(itemView.render().el);
        });
      }
      this.rewritePageLinks();
      this.trigger('rendered');
    },

    removeCheckedFromCart: function () {
      var ids = [],
        selected = this.getSelectedItems(),
        that = this;
      _.each(selected, function (itemView) {
        if (that.model.get(itemView.model.id) !== undefined) {
          ids.push(itemView.model.get('id'));
          that.childViews.itemViews = _.without(that.childViews.itemViews, itemView);
          Backbone.trigger('update-cart-item', itemView.model, 'delete');
          itemView.remove();
        }
      });
      this.model.deleteByItemsIds(ids);
    },

    /**
     * Извлекает Id продукта из модели
     * @param model Модель из которой извлекается Id продукта
     * @returns {int} Id продукта
     * @private
     */
    _getItemId: function (model) {
      return model.get('item_id');
    },
  });
})();

}.call(window));